import React, { useState } from "react";
import { Form, Input, Button, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../config/networkConfig";
// import md5 from "md5";
import { Logo } from "../../common/components/Logo";

export default function Login() {
  const dispatch = useDispatch();
  const [username, setUsername] = useState("");
  const [password, setPassowrd] = useState("");
  // const md5Pass = md5(password);

  const onPress = () => {
    if (username.length === 0 || password.length === 0) {
      message.error("Please enter username or password");
    } else {
      // backendLoginVerify({ username: username, pass: md5Pass })
      login({ username: username, password: password })
      .then((response) => {
        console.log(response);
        if(response.access_token){
          dispatch({ type: "sign_in", payload: response});
        }else {
          message.error("Username or Password wrong");
          document.getElementById("normal_login_password").select();
        }
      })
      .catch((e) => {
        console.log(e);
      });
    }
  };

  return (
    <div className="loginBody">
      <div className="loginLogo">
        <Logo logoType="login"/>
        {/* <img src={logo.logo} alt="Logo" style={{ maxWidth: "80%" }} /> */}
      </div>

      <div className="loginFieldBg">
        <div style={{ margin: 10 }}>
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
          >
            <Form.Item
              preserve={false}
              name="username"
              rules={[
                { required: true, message: "Please input your Username!" },
              ]}
            >
              <Input
                style={{ height: "50px" }}
                prefix={<UserOutlined className="site-form-item-icon" />}
                placeholder="Username"
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please input your Password!" },
              ]}
            >
              <Input
                style={{ height: "50px" }}
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="Password"
                onChange={(e) => {
                  setPassowrd(e.target.value);
                }}
              />
            </Form.Item>

            <Form.Item>
              <Link to="/">
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                  onClick={onPress}
                >
                  Login
                </Button>
              </Link>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}
